/** A point in time, written relative to now, with the exact date as a tooltip. */
import { html } from 'lit';

import { dateTime, timeAgo } from '../format.js';

export const when = (iso, fallback = '—') =>
  iso ? html`<time datetime=${iso} title=${dateTime(iso)}>${timeAgo(iso)}</time>` : html`<span class="muted">${fallback}</span>`;
